
import { Options, Vue } from "vue-class-component";
import MCommentPanel from "@/components/MCommentPanel.vue";
import { getWaitingStudents, WaitingStudent } from "@/api/room_reservations";
import store, { awaitStudentLoaded } from "@/store";
import dayjs from "dayjs";

@Options({
  components: {
    MCommentPanel
  }
})
export default class WaitingView extends Vue {
  roomUrl = "";
  roomHost = "";
  secondsToWait = 0;
  timer = 0;
  timeText = "";
  groupName = "";
  myWaitingData?: WaitingStudent;

  setTimer() {
    if (!this.myWaitingData) return;
    const { startOn } = this.myWaitingData.data;
    const diff = startOn - dayjs().unix();
    this.secondsToWait = diff > 0 ? diff : 0;
    if (this.timer) clearInterval(this.timer);
    if (this.secondsToWait > 0) {
      this.timer = setInterval(() => {
        this.secondsToWait = this.secondsToWait - 1;
        if (this.secondsToWait <= 0) {
          clearInterval(this.timer);
          location.href = this.roomUrl;
        }
      }, 1000);
    } else {
      location.href = this.roomUrl;
    }
  }

  async created() {
    const student = await awaitStudentLoaded(store);
    const nextReservation = store.getters.involvedRoomReservations[0];
    if (!nextReservation) {
      this.$router.push("/");
    }
    const waitingStudents = await getWaitingStudents(nextReservation.ref.id);
    this.myWaitingData = waitingStudents.find(
      _ => _.data.studentId === student.ref.id
    );
    if (!this.myWaitingData) {
      this.$router.replace("/");
      return;
    }
    const {
      studentId,
      classroomId,
      schoolId,
      mtelHost,
      goal,
      gradeText,
      displayName,
      subjectsText,
      startOn,
      endOn
    } = this.myWaitingData.data;
    if (!mtelHost) {
      this.$router.push("/");
      return;
    } else if (
      localStorage[`room_${dayjs.unix(endOn).format("YYYY-MM-DD-HH-mm")}`] !==
      this.myWaitingData.ref.id
    ) {
      alert(
        "すでにほかの機械（きかい）でさんかしているようです。\nその機械ではいるか、ヘルプからおといあわせください。"
      );
      location.href = "/";
      return;
    }
    this.groupName = nextReservation.data.groupName;
    this.roomHost =
      process.env.VUE_APP_FIREBASE_PROJECT_ID === "mingaku-jp-dev"
        ? "https://mintel-dev.web.app"
        : process.env.VUE_APP_FIREBASE_PROJECT_ID === "mingaku-st"
        ? "https://mintel-st.web.app"
        : "https://mintel-jp.web.app";
    this.roomUrl = encodeURI(
      `${this.roomHost}/room/?mtelHost=${mtelHost}&returnTo=${
        location.origin
      }/reflection&goal=${goal}&groupName=${
        this.groupName
      }&gradeText=${gradeText}&prefecture=${student.data.prefecture ??
        ""}&displayName=${displayName}&subjectsText=${subjectsText}&studentId=${studentId}&classroomId=${classroomId}&schoolId=${schoolId}&waitingStudentPath=${this
        .myWaitingData.ref.parent.parent?.id ?? ""},${
        this.myWaitingData.ref.id
      }`
    );
    this.timeText = `${dayjs
      .unix(startOn)
      .format("M/D（ddd） HH:mm")} 〜 ${dayjs.unix(endOn).format("HH:mm")}`;
    this.setTimer();
    window.addEventListener("focus", this.setTimer);
  }
  destroyed() {
    window.removeEventListener("focus", this.setTimer);
  }
}
